export const STORAGE_CONSTANTS = {
  TOKEN_NAME: '_ut',
  SELECTED_TENANT: '_tenant'
}
